import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { haptic } from '@/lib/tg';

interface Props {
  title: string;
  subtitle?: string;
  onBack?: () => void;
  right?: React.ReactNode;
}

export function TopBar({ title, subtitle, onBack, right }: Props) {
  const nav = useNavigate();
  const handleBack = onBack ?? (() => {
    haptic('light');
    nav(-1);
  });
  return (
    <header className="safe-top sticky top-0 z-10 bg-tg-bg border-b border-tg-secondaryBg">
      <div className="flex items-center h-12 px-3 gap-2">
        <button onClick={handleBack} className="p-1 rounded-lg hover:bg-tg-secondaryBg">
          <ChevronLeft className="w-6 h-6" />
        </button>
        <div className="flex-1 min-w-0">
          <h1 className="font-semibold truncate">{title}</h1>
          {subtitle && <p className="text-xs text-tg-hint truncate">{subtitle}</p>}
        </div>
        {right}
      </div>
    </header>
  );
}
